var HorizontalBarChartModule = /** @class */ (function () {
    function HorizontalBarChartModule() {
    }
    return HorizontalBarChartModule;
}());
export { HorizontalBarChartModule };
